import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getMail, uploadEditorImage } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { getPageDetail, updatePage, uploadArticleImage,  commonAPI, approvePage } from '../../API/FetchCall';
import Autosuggest from 'react-autosuggest';

import { EditorState, convertToRaw, convertFromHTML, convertFromRaw, ContentState } from 'draft-js';
//import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';

import { Editor } from '@tinymce/tinymce-react';
import { TINY_EDITOR } from '../../constant';

import axios from 'axios';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class cmsAddEditSpecialGuest extends Component {

    constructor(props) {
        super(props);
        this.state = {
          logged: localStorage.getItem("authentication"),
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          write_permission: true,
          id: 0,
          page_title: '',
          insight_desc: '',
          banner_image: '',
          banner_new: '',
          gallery_image: '',
          article_images: '',
          show_upload: false,
          articleuploaded: false,
          gallery_new: '',
          insight_content: '',
          insight_author: '',
          about_author: '',
          related_vertical:'',
          social_links: [{ id: "fb", name: 'Facebook', link: "" }, { id: "li", name: 'LinkedIn', link: "" },
          { id: "in", name: 'Instagram', link: "" }],
          imageList: [],
          suggestions: [],
          location: [],
          locationList: [],
          categorylist:[],
          btnDisable: false,
          category:'',
          featured:0,
          editorState: EditorState.createEmpty()
        };
         this.getLocation();
         this.handleEditorChange = this.handleEditorChange.bind(this);
         this.approveBlog = this.approveBlog.bind(this);
        this.id = this.props.match.params.id ? this.props.match.params.id : '';
    }


    componentDidMount() {

      var THIS = this;
      
      if(this.id!='')
      this.getGuestPageDetail(this.id);

      

    }

 
 handleEditorChange(value, editor) {
    this.setState({
      insight_content: value
    });
  }
 

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleCheck = (e) => {
    this.setState((prevState) => ({
      show_upload: !prevState.show_upload,
    }));
  };
  customChange = (e, i) => {
    let social_links = this.state.social_links;
    if (social_links.length > 0 && social_links[i]) {
      social_links[i].link = e.target.value;
    }
    this.setState({ social_links });
  };
  handleFile = (e) => {
    const propName = e.target.name;
    const files = e.target.files[0];
    this.setState({
      [propName]: files
    });
  };

  uploadImageCallBack = (e) => {
    const propName = e.target.name;
    var files = e.target.files;
    this.setState({
      [propName]: files
    });
  };

  handleFileMultiple = (e) => {
    const propName = e.target.name;
    var files = e.target.files;
    if (files.length > 2) {
      files = '';
      let toastr = window.toastr.error; //warning
      toastr('', 'Select Article 2 Images Only', {
        positionClass: "toast-bottom-right",
        containerId: "toast-bottom-right"
      });
    }
    this.setState({
      [propName]: files
    });
  };
  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
  }

    getGuestPageDetail = () => {
      let ins = JSON.stringify({
        id:this.id
      });
      getPageDetail(ins).then((res) => {
        if (res.status == 1) {
          var data = res.detail;
          this.setState({
          id:data.id,
          page_title: data.title,
          slug_term:data.slug_term,
          social_links: data.social_links ? JSON.parse(data.social_links) : this.state.social_links,
          banner_image: data.banner_image ? res.base_url + data.banner_image : '',
          gallery_image: data.gallery_image ? res.base_url + data.gallery_image : '',
          status:data.status,
          editorState:EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(res.detail.detail_content)))
            
          });

          this.setState({ 
            consigne:EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(res.detail.detail_content))) 
          })

        } else {
          this.setState({
            insightDetail: '',
          });
        }
      });
    }    
 

 


  
  onChange = (event, { newValue, method }) => {
    this.setState({
      insight_author: newValue
    });
  };

  approvePage  = (e) => {


    let insert =  JSON.stringify({
      id: this.state.id,
      status :1
    });
    
    approvePage(insert).then((response) => {
      this.setState({
        btnDisable: false
      })
      if (response.status == 1) {
         
         NotificationManager.success('The Page is approved successfully..redirecting to list');

         window.location.href='/cms/specialguests';
         //alert("Insight is added");
      }
  });

  }


  handleSubmit = (e) => {


      let insert = {
        id: this.state.id,
        page_title: this.state.page_title,
        description: this.state.description,
        slug_term:this.state.slug_term,
        social_links: JSON.stringify(this.state.social_links),
        banner_new: this.state.banner_new,
        gallery_new: this.state.gallery_new
      }
      updatePage(insert).then((response) => {
        this.setState({
          btnDisable: false
        })
        if (response.status == 1) {
           if(this.state.insight_id=='')
           NotificationManager.success('Page is added successfully..redirecting to list');
           else
           NotificationManager.success('Page is updated successfully..redirecting to list');

           window.location.href='/cms/insights';
           //alert("Insight is added");
        } else {
           //alert("Issue in adding insight");
           NotificationManager.success('Page is added successfully..redirecting to list');
        }
      });
 

  }

  onChangeEditor = (editorState) => {
    //const contentState = editorState.getCurrentContent();
    //console.log("plain text", editorState.getCurrentContent().getPlainText());

    const contentState = draftToHtml(convertToRaw(editorState.getCurrentContent()))

    console.log("html", contentState);
    //const raw = convertToRaw(contentState);
    this.setState({
      consigne:editorState,
      insight_content:contentState
    });
  }

    render() {

        const { insightDetail } = this.state;
        const { categorylist, suggestions } = this.state;
        const inputProps = {
          value: this.state.insight_author,
          onChange: this.onChange,
          name: 'insight_author',
          className: 'form-control'
        };

        const { insight_content, editorState, consigne} = this.state;
        const { login_id, role } = this.state.auth_data;

        return (
            <React.Fragment>
                <AdminLayout>
                    
             <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Guest Special Page - Add/Edit</h4>
                    

                   <div>
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Page Title <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='page_title' className='form-control' type='text' value={this.state.page_title}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>

                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Preferred URL (Never use special characaters as *,@,#,/,+,- and etc, except hyphen(-))</label>
                        </div>
                        <div class="form-group col-md-9">
                          <input name='slug_term' className='form-control' type='text' value={this.state.slug_term}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>


                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> About info / Description <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">
                          <textarea name='insight_desc' className='form-control' rows={3} value={this.state.insight_desc}
                            onChange={this.handleChange} />
                          
                        </div>
                      </div>
                      

                      
                      <div className="row">
                        <div class="form-group col-md-3">
                          <label> Banner Image <span className="astrick">* (*.png, .jpp or Better use .webp format) </span></label>
                        </div>
                        <div class="form-group col-md-9">
                       
                          <input
                            type="file"
                            name="page_banner"
                            onChange={this.handleFile}
                            className="form-control mar-btm"
                            accept="image/x-png,image/gif,image/jpeg"
                          />

                       
                        </div>
                        
                      </div>
                       
                      
                      
                     
                      <div className="row" style={{ marginBottom: '30px' }}>
                        <div class="form-group col-md-3">
                          <label> Content <span className="astrick">*</span></label>
                        </div>
                        <div class="form-group col-md-9">

                          <Editor
                            onEditorChange={this.handleEditorChange}
                            toolbar={{
                                inline: { inDropdown: true },
                                list: { inDropdown: true },
                                textAlign: { inDropdown: true },
                                link: { inDropdown: true },
                                history: { inDropdown: true },
                                image: { uploadCallback: this.uploadImageCallBack, alt: { present: true, mandatory: true } },
                              }}
                            value={this.state.insight_content}
                            name="insight_content"
                            apiKey={TINY_EDITOR}
                            init={{
                                  height: 300,
                                  theme:"silver",
                                  plugins: ["advlist autolink lists link anchor paste image"],
                                  file_picker_types: "file image media",
                                  toolbar: 'undo redo | formatselect | image| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help',
                                  //images_upload_handler: uploadImageCallBackServer
                                  images_upload_handler: async function(
                                                                          blobInfo:any,
                                                                          success: any,
                                                                          failure: any
                                                                        ) {
                                                                          let imageFile = new FormData();
                                                                          //imageFile.append("files[]", blobInfo.blob());
                                                                          imageFile.append('image', blobInfo.blob());
                                                                          try {
                                                                            const {data} = await axios.post("https://api.bewise.in/api/campaign/mail/uploadeditorimage", imageFile)
                                                                            success(data.data.link);
                                                                          } catch (error) {
                                                                            console.log(error);
                                                                            return;
                                                                          }
                                                                        }
                            }}
                   
                          />

                         
                        </div>
                      </div>

                       
                                             
                     
                      <div className="row mb-4 text-right">
                        <button type='submit' id="btnSubmit"
                          className="btn btn-primary btn-sm" onClick={this.handleSubmit} disabled={this.state.btnDisable} style={{ display: "block", margin: "auto" }}>
                          Submit
                        </button>
                      </div>
                      

                      {this.state.status==0 && login_id==1 && (
                        <div className="row mb-4 text-right">
                          <button type='submit' id="btnSubmit" onClick={this.approveBlog}
                            className="btn btn-primary btn-sm" style={{ display: "block", margin: "auto" }}>
                            Approve
                          </button>
                        </div>
                      )}

                    </div>


                  

                </div>
              </div>
            </div>  
            <NotificationContainer/>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


function uploadImageCallBackServer(file) {
  return new Promise(
    (resolve, reject) => {
      const reader = new window.FileReader();
      const xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
      //xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
      xhr.open('POST', 'https://api.bewise.in/api/campaign/mail/uploadeditorimage');
      xhr.setRequestHeader('x-auth-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kZXIiOnsiaWQiOiI1ZWJkMTMyOTQwMjJhMjNlMmM1YzA4MzkifSwiaWF0IjoxNTkxMTgwOTA3LCJleHAiOjM2MDAwMDAwMDAxNTkxMTgwMDAwfQ.TKBUep0bss3gqQBK8CkbUuRlO3jRLHEvGTGgm90gLRE');
      const data = new FormData(); // eslint-disable-line no-undef
      data.append('image', file);
      xhr.send(data);
      xhr.addEventListener('load', () => {
        const response = JSON.parse(xhr.responseText);
        resolve(response);
      });
      xhr.addEventListener('error', () => {
        const error = JSON.parse(xhr.responseText);
        reject(error);
      });
    },
  );
}

export default cmsAddEditSpecialGuest;


// WEBPACK FOOTER //
// ./src/components/bewise/cmsAddEditSpecialGuest.jsx